import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionElectService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_RSUElect_ElectionHistoryDto,
} from '../../services/wealthlane-award-settlement-services';

const useGetOptionAwardExerciseHistory = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_RSUElect_ElectionHistoryDto[] | undefined,
  unknown
> => {
  const optionAwardExerciseHistory = useQuery(['getOptionAwardExerciseHistory', id], async () => {
    return await handleRequest(
      OptionElectService.getApiAwardSettlementApiAppOptionElectExerciseHistoryList(id)
    );
  });

  return optionAwardExerciseHistory;
};

export default useGetOptionAwardExerciseHistory;
